import { number } from "echarts";

// 联级下拉选回显
const getParentsById = (arr, id) => {
  for (const i in arr) {
    if (arr[i].id == id) {
      return [arr[i].id];
    }
    if (arr[i].nodes) {
      const node = getParentsById(arr[i].nodes, id);
      if (node !== undefined) {
        //查询到把父节把父节点加到数组前面
        node.unshift(arr[i].id);
        return node;
      }
    }
  }
};
// 联级下拉子级为空不显示
const getTreeData = (data,id) => {
  for (let i = 0; i < data.length; i++) {
    if(data[i].id == id){
      data[i].disabled = true
    }
    if(data[i].nodes){
      if (data[i].nodes.length < 1) {
        // 最后一级没有数据将children变成undefined
        data[i].nodes = undefined;
      } else {
        // children不为空时继续调用该方法
        getTreeData(data[i].nodes);
      }
    }
    
  }
  return data;
};

// 时间转换为分钟
const swapMinute = (data) => {
  const dayMinute = data.day * 24 * 60;
  const hourMinute = data.hour * 60;
  const minute = data.minute;
  return Number(dayMinute) + Number(hourMinute) + Number(minute);
};

// 时间转换为分钟
const minute = (value) => {
  var result = "";
  var sencond = parseInt(value);
  var day = sencond / (60 * 24);
  sencond = sencond % (60 * 24); //求天数整除外剩余的秒数
  var hour = sencond / 60;
  var minute = sencond % 60;
  result = {
    day: parseInt(day),
    hour: parseInt(hour),
    minute: parseInt(minute),
  };
  return result;
};

const filterLeftData = (list, rightIds, newList)=> {
  for (const leftItem of list) {
    if (rightIds.includes(leftItem.id)) {
      if (leftItem.nodes && leftItem.nodes.length) {
        let insetBool = false;
        for (const child of leftItem.nodes) {
          // if (!rightIds.includes(child.id)) insetBool = true
          if (rightIds.includes(child.id)) {
            if (child.nodes && child.nodes.length) {
              for (const child1 of child.nodes) {
                // if (!rightIds.includes(child1.id)) insetBool = true;
                if (rightIds.includes(child1.id)) {
                    if (child1.nodes && child1.nodes.length) {
                      for (const child2 of child1.nodes) {
                        // if (!rightIds.includes(child2.id)) insetBool = true;
                        if (rightIds.includes(child2.id)) {
                            if (child2.nodes && child2.nodes.length) {
                              for (const child3 of child2.nodes) {
                                // if (!rightIds.includes(child3.id)) insetBool = true;
                                if (rightIds.includes(child3.id)) {
                                  if (child3.nodes && child3.nodes.length) {
                                    for (const child4 of child3.nodes) {
                                      if (!rightIds.includes(child4.id)) insetBool = true;
                                    }
                                  }
                                } else {
                                  insetBool = true; 
                                }
                              }
                            }
                          } else {
                            insetBool = true; 
                          }
                      }
                    }
                  } else {
                    insetBool = true;
                  }
              }
            }
          } else {
            insetBool = true;
          }
        }
        if (insetBool) {
          const jsonItem = JSON.parse(JSON.stringify(leftItem));
          jsonItem.nodes = [];
          newList.push(jsonItem);
          filterLeftData(leftItem.nodes, rightIds, jsonItem.nodes);
        }
      }
    } else {
      const jsonItem = JSON.parse(JSON.stringify(leftItem));
      jsonItem.nodes = [];
      newList.push(jsonItem);
      filterLeftData(leftItem.nodes, rightIds, jsonItem.nodes);
    }
  }
  return newList;
}


export default {
  getParentsById,
  getTreeData,
  swapMinute,
  minute,
  filterLeftData
};
